import { publishEvent } from '../../utils'
import { Button } from 'reactstrap'

export default function AppObjectCancelButton(props) {
  console.log('AppObjectCancelButton rendered', props)
  const { object, refListId } = props

  function cancelButtonClicked() {
    console.log('AppObjectActionButton.cancelButtonClicked')
    if (refListId) {
      publishEvent(`CANCEL CHILD CHANGES ${refListId}`, null, 'AppObjectCancelButton.cancelButtonClicked')
    } else {
      publishEvent(`CANCEL CHANGES ${object.id}`, null, 'AppObjectCancelButton.cancelButtonClicked')
    }
  }

  return (
    <Button
      style={{ marginLeft: '20px' }}
      data-cy="app-object-action-cancel-button"
      onClick={cancelButtonClicked}>Cancel</Button>
  )
}